/**
 * @desc 公告信息
 * @author zhuxusheng@zbj.com
 * @since 2019-11-07
 */
'use strict';
module.exports = {
	'noticeList': [
		{
			title: '严正申明',
			releaseDate: '2026/05/15',
			isImage: true,
			content: `20260515.png`
		},
		{
			title: '严正申明',
			releaseDate: '2025/04/03',
			isImage: true,
			content: `20250403.png`
		},
		{
			title: '严正申明',
			releaseDate: '2023/11/30',
			isImage: true,
			content: `20231130.png`
		},
		{
			title: '严正申明',
			releaseDate: '2022/09/30',
			isImage: true,
			content: `20220930.png`
		},
		{
			title: '严正申明',
			releaseDate: '2022/08/18',
			isImage: true,
			content: `20220818.png`
		},
		{
			title: '严 正 申 明',
			releaseDate: '2020/06/02',
			content: `
							<p style="color:#444444;font-size:14px;line-height:30px;"></p>
							<p style="color:#444444;font-size:14px;line-height:30px;text-indent:2em;">近期，据个别消费者向我司反馈/举报，称其通过不明链接下载了一款与我司贷款产品“戒易花”同名的客户端应用程序（以下称“APP”），在签订《借款合同》后未收到贷款，并收到短信要求缴纳保证金。</p>
							<p style="color:#444444;font-size:14px;line-height:30px;"></p>
							<p style="color:#444444;font-size:14px;line-height:30px;text-indent:2em;">经核查，该APP并非我司发布、运营，且该APP涉嫌盗用并篡改我司及我司关联公司重庆猪八戒金融服务有限公司信息从事非法活动，已涉嫌犯罪。为保障广大消费者的合法权益，本公司在此严正申明：</p>
							<p style="color:#444444;font-size:14px;line-height:30px;"></p>
							<p style="color:#444444;font-size:14px;line-height:30px;text-indent:2em;">1、重庆市猪八戒宜创小额贷款有限公司系正规持牌小额贷款公司，旗下“戒易花”、“八戒金融”APP仅在华为、小米、OPPO等正规应用市场发布。为保护您的个人信息及资金安全，请前往正规应用市场下载并使用，切勿点击不明链接进行下载。</p>
							<p style="color:#444444;font-size:14px;line-height:30px;"></p>
							<p style="color:#444444;font-size:14px;line-height:30px;text-indent:2em;">2、重庆市猪八戒宜创小额贷款有限公司系“戒易花”、“八戒金融”唯一放款主体，凡《借款合同》中出借人名称为“重庆八戒金融服务有限公司”，均非我司贷款产品。</p>
							<p style="color:#444444;font-size:14px;line-height:30px;"></p>
							<p style="color:#444444;font-size:14px;line-height:30px;text-indent:2em;">3、我司不会以您收款账户信息错误导致放款失败为名，要求您向任何个人账户缴纳保证金。</p>
							<p style="color:#444444;font-size:14px;line-height:30px;"></p>
							<p style="color:#444444;font-size:14px;line-height:30px;text-indent:2em;">4、如遇前述情形，请立即向公安机关进行举报、维权。</p>
							<p style="color:#444444;font-size:14px;line-height:30px;"></p>
							<p style="color:#444444;font-size:14px;line-height:30px;">特此申明！</p>
							<p style="color:#444444;font-size:14px;line-height:30px;"></p>
							<p style="color:#444444;font-size:14px;line-height:30px;"></p>
							<p style="color:#444444;font-size:14px;line-height:30px;text-align:right;">重庆市猪八戒宜创小额贷款有限公司</p>
							<p style="color:#444444;font-size:14px;line-height:30px;text-align:right;">2020年 6 月 2 日</p>
							<p style="color:#444444;font-size:14px;line-height:30px;"></p>
							<p style="color:#444444;font-size:14px;line-height:30px;"></p>`

		},
		{
			title: '公    告',
			releaseDate: '2020/05/18',
			content: `<p style="color:#444444;font-size:14px;line-height:30px;"></p>
								<p style="color:#444444;font-size:14px;line-height:30px;">尊敬的各位用户：</p>
								<p style="color:#444444;font-size:14px;line-height:30px;text-indent:2em;">由于本司支付系统升级，现“提前收款”功能可能会发生扣款不成功或重复扣款故障，请您立即联系我司，我司将安排专人为您服务。对此给您带来的不便，我司深表歉意！我司将尽快恢复正常扣款，并衷心感谢您的理解和支持！</p>
								<p style="color:#444444;font-size:14px;line-height:30px;height:30px;"></p>
								<p style="color:#444444;font-size:14px;line-height:30px;height:30px;"></p>
								<p style="color:#444444;font-size:14px;line-height:30px;">联系方式：</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">客服电话：023-88392602；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">微信公众号：关注并进入微信公众号“起点分期ZBJ”→点击界面右下角“我的”→点击“联系客服”。</p>`
		},
		{
			title: '严正申明',
			releaseDate: '2020/04/03 00:00',
			isImage: true,
			content: 'affirming.jpg'
		},
		{
			title: '网贷“十不准”',
			releaseDate: '2019/08/12 09:21',
			content: `<p style="color:#444444;font-size:14px;line-height:30px;"></p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(一)不准在重庆市外办理线下自营贷款业务；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(二)不准通过网络平台在重庆市外办理委托贷款业务；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(三)不准通过网络平台在重庆市外办理股权投资类业务；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(四)不准通过网络平台为本公司融入资金；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(五)不准通过网络平台非法集资和吸收公众存款；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(六)不准通过网络平台销售、转让本公司的信贷资产和贷款债权；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(七)不准通过网络平台发放违反法律有关利率规定的贷款；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(八)不准隐瞒客户应知晓的本公司有关信息和擅自使用客户信息、非法买卖或泄露客户信息；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(九)不准在重庆市外的银行开立本公司的基本账户；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;"></p>
								<p style="color:#444444;font-size:14px;line-height:30px;"></p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(十)不准在公司账外核算网络贷款的本金、利息和有关费用。</p>`
		},
		{
			title: '小贷“十不准”',
			releaseDate: '2019/07/12 22:21',
			content: `<p style="color:#444444;font-size:14px;line-height:30px;">(一)不准非法集资和吸收公众存款；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(二)不准发放利率违反法律有关规定的贷款；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(三)不准采取暴力、恐吓等手段非法收贷；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(四)不准抽逃注册资金；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(五)不准做虚假帐务、报虚假信息和帐外经营；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(六)不准违规跨经营区域发放贷款；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(七)不准开办未经监管部门批准的任何业务；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(八)不准超范围超比例投资；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(九)不准突破单户贷款比例；</p>
								<p style="color:#444444;font-size:14px;line-height:30px;">(十)不准违规变更有关事项。</p>`
		}
	]
}



// WEBPACK FOOTER //
// ./app/resource/global/js/staticData/notice.js